function hoursUpdate() {
	// uses spacetime:
	// https://github.com/spencermountain/spacetime
	const todayUserLocation = spacetime.now();
	const todayVancouver = todayUserLocation.goto('America/Vancouver');

	const onlineText = 'Available by phone<div class="dot"></div>';
	const offlineText = 'Email info@riversol.com';

	var open = todayVancouver.clone();
	var close = todayVancouver.clone();

	var online = true;
	function setOnlineDateTime() {
		if (gorgiasBusinessHoursIsOpen != null){
			online = gorgiasBusinessHoursIsOpen;
			console.log(`Chat ${ online ? "Online" : "Offline"}: Gorgias`);
		} else {
			if (todayVancouver.dayName() == "Sunday") {
				online = false
			} else if (todayVancouver.dayName() == "Saturday") {
				// Sat: 8:00am to 4:00pm PST
				open = open.time('8:00am');
				close = close.time('4:00pm');
				online = todayVancouver.isBetween(open, close, true);
			} else if (todayVancouver.dayName() == "Friday") {
				// Fri 3:00am to 5:00pm PST
				open = open.time('3:00am');
				close = close.time('5:00pm');
				online = todayVancouver.isBetween(open, close, true);
			} else {
				// Mon - Thu 3:00am to 8:00pm PST
				open = open.time('3:00am');
				close = close.time('8:00pm');
				online = todayVancouver.isBetween(open, close, true);
			}
			console.log(`Chat ${ online ? "Online" : "Offline"}: Default`);
		}

		if (online == false) {
			$('.phone-contact span').addClass("offline").html(offlineText);
			if ( $('.contact-us-blue-block').length) {
				$('.contact-us-blue-block .btn--secondary').css('display', 'none');
			}
		} else { 
			$('.phone-contact span').addClass("online").html(onlineText);
		}
		
			if (online == false) {
				$('#qualified-about .about-connect-button').addClass("offline");
			} else { 
				$('#qualified-about .about-connect-button').addClass("online");
			}
		
	}
	setOnlineDateTime();
}
$( document ).ready(function() {
	//Menu scroll fix
	$(".icon-menu").on('click', function() {
		$('body').toggleClass('blocked');
	});

	//Auto submit currency change form on select change 
	$(".shopify-currency-form select").on('change', function() {
		// console.log("change");
		$(this).parents('form').submit();
	});

	//Set phone availability
	hoursUpdate();
	

	//Prevent vertical scrolling when swiping left/right on flickity
	(function() {
		let touchingCarousel = false,
		touchStartCoords;

		document.body.addEventListener('touchstart', function(e) {
			if (e.target.closest('.flickity-slider')) {
				touchingCarousel = true;
			} else {
				touchingCarousel = false;
				return;
			}

			touchStartCoords = {
				x: e.touches[0].pageX,
				y: e.touches[0].pageY
			}
		});

		document.body.addEventListener('touchmove', function(e) {
			if (!(touchingCarousel && e.cancelable)) {
				return;
			}

			let moveVector = {
				x: e.touches[0].pageX - touchStartCoords.x,
				y: e.touches[0].pageY - touchStartCoords.y
			};

			if (Math.abs(moveVector.x) > 7)
				e.preventDefault()

		}, {passive: false});
	})

	();

	if (window.document.documentMode) {
	  // Do IE stuff
	  $( "#shopify-section-header" ).before( '<div class="top-header-ie">Users of Internet Explorer may experience some difficulties using this site. Please use a different browser for best results.<span class=""></span></div>' );

	}

    var $menu = $(".site-nav");

    $menu.menuAim({
        activate: activateSubmenu,
        deactivate: deactivateSubmenu,
        activationDelay: 200,
        submenuDirection: "below",
        exitMenu: closeSubmenu,
	    tolerance: 0,
        rowSelector: ".main-menu > li"
    });

    function activateSubmenu(row) {
        var $row = $(row),
            submenuId = $row.data("submenuId"),
            $submenu = $("#" + submenuId),
            height = $menu.outerHeight(),
            width = $menu.outerWidth();

        // Show the submenu
        $submenu.css({
            visibility: "visible",
            left: 0,
            right: 0,
            opacity: 1
        });

        $('#MainContent').addClass('coverMainPage');


        // Keep the currently activated row's highlighted look
        $row.find("a").addClass("maintainHover");
    }

    function deactivateSubmenu(row) {
        var $row = $(row),
            submenuId = $row.data("submenuId"),
            $submenu = $("#" + submenuId);

        $submenu.css({
            visibility: "hidden",
            opacity: 0
        });
        $row.find("a").removeClass("maintainHover");
        $('#MainContent').removeClass('coverMainPage');
    }

    function closeSubmenu() {
        if($('#submenu-shop').is(':hover')){
	        // console.log("triggered but do not close test");
	        return(isHovering);
	    } else {
	        // console.log("closed test");
	    	return(true)
	    }

    }
    $( '.product-col' ).click(function() {
    	var collection_option = $(this).data( "target" );
    	$(collection_option).toggleClass('open-tab');
		$('.main-menu').toggleClass('second-nav-open');
    });

    $('.touch__nav .touch__nav__close').click(function() {
    	$('.second-nav').removeClass('open-tab');
		$('.main-menu').removeClass('second-nav-open');    	
    });

});